import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Text from "@/bit/components/next13.components.text";
import Glyph from "@/bit/components/next13.components.glyph";
import { colors, grid } from "../../constants";

const MainBubble = (props) => {
  const title = props["Text-1"];
  const icon = props["Glyph-1"];

  const glyph = useMemo(() => <Glyph {...icon} />, [icon.id]);

  return (
    <>
      <div className="main-bubble" data-cy="Ecosystem Main Bubble">
        <div className="content-container">
          <div className="outer-bubble"></div>
          <div className="inner-bubble"></div>
          <div className="icon-container" data-cy="Ecosystem Main Bubble Icon">{glyph}</div>
          {title && <Text {...title} size="caption01" kind="span" cyData="Ecosystem Main Bubble Title" />}
        </div>
      </div>
      <style jsx>{`
        .main-bubble {
          position: absolute;
          transform: translate(-50%, -50%);
          top: 50%;
          left: 50%;
          opacity: 0.95;
          margin: 0 auto;

          .content-container {
            width: 6.875rem;
            height: 6.875rem;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;
            border-radius: 100%;
            position: relative;

            .inner-bubble,
            .outer-bubble {
              position: absolute;
              transform: translate(-50%, -50%);
              top: 50%;
              left: 50%;
              border-radius: 100%;
              width: 100%;
              height: 100%;
              z-index: -1;
              transition: all 200ms linear;
            }

            .outer-bubble {
              background-color: #019ff469;
              transform: translate(-50%, -50%)
                scale(${props.isActive ? "110%" : "100%"});
            }

            .inner-bubble {
              background-color: ${colors.color_gp__blue};
              transform: translate(-50%, -50%)
                scale(${props.isActive ? "90%" : "100%"});

              ${props.isActive
                ? "box-shadow: rgba(255, 255, 255, 0.3) 0 0 20px;"
                : ""}
            }
          }
        }

        // Tablet
        @media screen and (min-width: ${grid.breakpoint_sm}px) {
          .main-bubble {
            .content-container {
              width: min(10rem, 15vw);
              height: min(10rem, 15vw);

              :global(.icon-container) {
                :global(.svg-layout-size) {
                  width: 2.5rem !important;
                  height: 2.5rem !important;

                  & > :global(svg) {
                    width: 2.5rem !important;
                    height: 2.5rem !important;
                  }
                }
              }
            }
          }
        }
        // Desktop
        @media screen and (min-width: ${grid.breakpoint_md}px) {
        }

        @keyframes main-bubble-anim {
          0% {
            transform: translate(-50%, -50%) scale(100%);
          }
          50% {
            transform: translate(-50%, -50%) scale(80%);
          }
          100% {
            transform: translate(-50%, -50%) scale(100%);
          }
        }
      `}</style>
    </>
  );
};

MainBubble.propTypes = {};

MainBubble.defaultProps = {};

export default MainBubble;

// background-color: ${props.isActive
//   ? "#019ff469"
//   : colors.color_gp__blue};
